import { useState } from 'react';

/**
 * Holds the saved flag shown by the progress loading indicator. Keeps it in local state initialised to false.
 *
 * @returns An object carrying the isSaved flag.
 */
const useProgressLoading = () => {
  const [isSaved, setIsSaved] = useState(false);

  return {
    isSaved,
  };
};

export default useProgressLoading;
